"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapshotsPerHourDialog = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
require("./types");
const core_2 = require("../../../core");
const SnapshotsPerHourDialog = ({ initialValue = 1, deactivate, onDone, rowName, }) => {
    const { t } = core_2.useFeatureContext();
    const model = core_1.useModelBuilder({
        count: initialValue,
    });
    const { value: modelValue } = core_1.useModel(model);
    const form = core_1.useForm(model, {
        validationSchema: {
            count: [core_1.required(), core_1.minNumber(1), core_1.maxNumber(60)],
        },
    });
    const { isValid } = core_1.useFormMeta(form);
    return (react_1.default.createElement(components_1.Dialog, { id: "snapshotsPerHourDialog", header: t('snapshotPerHourDialog|title'), size: {
            width: components_1.DIALOG_SIZE.xs,
            height: components_1.DIALOG_SIZE.auto,
        }, onRequestClose: deactivate, actions: [
            {
                id: 'apply',
                view: components_1.ACTION_VIEW.primary,
                disabled: !isValid,
                text: t('snapshotPerHourDialog|btnApplyLabel'),
                onClick: () => {
                    onDone(modelValue.count);
                    deactivate();
                },
            },
            {
                id: 'cancel',
                view: components_1.ACTION_VIEW.secondary,
                text: t('snapshotPerHourDialog|btnCancelLabel'),
                onClick: () => {
                    deactivate();
                },
            },
        ] },
        react_1.default.createElement(components_1.FormLayout, { inlineLabel: true },
            react_1.default.createElement(components_1.NumberField, { label: t('snapshotPerHourDialog|numberFieldLabel', {
                    rowName,
                }), field: form.fields.count, size: components_1.CONTROL_SIZE.xxs, minValue: 1, maxValue: 60 }))));
};
exports.SnapshotsPerHourDialog = SnapshotsPerHourDialog;
//# sourceMappingURL=SnapshotsPerHourDialog.js.map